function getExtensionFromBase64(data) {
    const match = data.match(/^data:image\/([a-zA-Z0-9+.-]+);base64,/);
    if (match) {
        return match[1];
    }
    return null;
}

function getFileExtension(filename) {
    if (!filename) {
        return '';
    }

    // strip query/hash fragments and normalize case
    let clean = filename.split('#')[0].split('?')[0];
    let parts = clean.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getContentType(filename) {
    let ext = getFileExtension(filename);
    let type = '';

    switch (ext) {
        case 'mp4':
        case 'm4v':
        case 'mov':
        case 'webm':
            type = 'video/mp4';
            break;
        case 'm3u8':
            type = 'video/hls';
            break;
        case 'gif':
            type = 'image/gif';
            break;
        case 'png':
            type = 'image/png';
            break;
        case 'jpg':
        case 'jpeg':
            type = 'image/jpeg';
            break;
        default:
            break;
    }
    return type;
}

export { getExtensionFromBase64, getFileExtension, getContentType };
